import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
		},

		bgImage: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundPositionY: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',

			'&:after': {
				content: '""',
				backgroundColor: 'transparent',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
			},
		},
		gridItem: {
			width: '100%',
		},

		container: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
		},
		title: {
			marginBottom: theme.spacing(3.25),
			textAlign: 'center',

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},
		text: {
			marginBottom: theme.spacing(2),
			textAlign: 'center',
			width: '100%',

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},

		image: {
			maxWidth: theme.spacing(46.75),
			marginBottom: theme.spacing(4.75),
			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},

		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'center',

			[theme.breakpoints.down('sm')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},

		button: {
			width: 'auto',
			marginBottom: theme.spacing(1.75),

			[theme.breakpoints.down('sm')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
		list: {
			display: 'flex',
			flexWrap: 'wrap',
			marginBottom: theme.spacing(3.75),

			[theme.breakpoints.down('sm')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},
	}),
	{ name: 'CallToAction-Cta16_17' },
)

export default useStyles
